<!-- src/components/LogUpdate.vue -->
<template>
  <v-container
    class="mt-2"
    style="border: 1px solid #e0e0e0;"
  >
    <v-row no-gutters>
      <v-col>
        <span><b>Valor alterado: </b> {{ log.attribute }} </span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <span><b>De: </b> {{ log.old_value }} <b>para: </b> {{ log.new_value }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <span><b>Alterado por: </b> {{ log.user.name }} </span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <span><b>Data: </b> {{ log.date }} </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LogUpdate',
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
}
</script>
